export const APP_ENTITIES_PERMISSIONS = {
  READ: 'READ',
  UPDATE: 'UPDATE',
  REMOVE: 'REMOVE'
}
